import { useRef } from "react";
import { ExternalLink, FileText } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { BACKEND_URL } from "@/lib/api";

export const sheetUrl = (path) => `${BACKEND_URL}${path}`;
export const fmtSize = (b) => {
  if (!b) return "";
  const mb = b / 1024 / 1024;
  return mb < 0.1 ? `${Math.max(1, Math.round(b / 1024))} KB` : `${mb.toFixed(1).replace(".", ",")} MB`;
};

// Vollbild-Ansicht eines Datenblatts – zum Zeigen im Kundengespräch (Tablet/Laptop).
export function DatasheetViewer({ sheet, onClose }) {
  const openRef = useRef(null);
  const url = sheet ? sheetUrl(sheet.path) : "";
  return (
    <Dialog open={!!sheet} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        onOpenAutoFocus={(e) => { e.preventDefault(); openRef.current?.focus(); }}
        className="max-w-none w-screen h-[100dvh] sm:w-[96vw] sm:h-[94vh] p-0 gap-0 bg-[#09090B] border-zinc-800 flex flex-col overflow-hidden sm:rounded-2xl"
        data-testid="datasheet-viewer"
      >
        <div className="flex items-center gap-3 px-4 py-3 pr-12 border-b border-zinc-800 bg-[#18181B]">
          <div className="h-9 w-9 rounded-lg bg-[#00E575]/12 border border-[#00E575]/30 flex items-center justify-center shrink-0">
            <FileText size={16} className="text-[#00E575]" />
          </div>
          <div className="min-w-0 flex-1">
            <DialogTitle className="text-[14px] font-bold text-zinc-100 truncate" data-testid="datasheet-viewer-title">
              {sheet?.title || "Datenblatt"}
            </DialogTitle>
            <DialogDescription className="text-[11.5px] text-zinc-400 truncate">{sheet?.filename}</DialogDescription>
          </div>
          <a
            ref={openRef}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="datasheet-viewer-open-tab"
            className="h-9 px-3 rounded-lg bg-[#00E575] text-[#09090B] text-[12.5px] font-bold inline-flex items-center gap-1.5 hover:bg-[#00C964] active:scale-95 transition-transform shrink-0"
          >
            <ExternalLink size={14} /> Vollbild
          </a>
        </div>
        <div className="flex-1 overflow-auto bg-zinc-900" style={{ WebkitOverflowScrolling: "touch" }}>
          {sheet && (
            <iframe title={sheet.title || "Datenblatt"} src={url} className="w-full h-full border-0 bg-white" data-testid="datasheet-viewer-frame" />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
